import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import CurrencyFormat from 'react-currency-format';

const MapReport = (props) => {

    const {list} = props;

    return(
            <>
                {list.length > 0 && <Box>
                    <Grid spacing={2}  container={true}>
                        {list.map((report, index) => {
                            return (
                                <Grid key={index} item xs={12} sm={4} md={3}>
                                    <Paper className='animate__animated animate__flipInX' style={{ padding: '10px 0px', textAlign: "center", margin: '5px 0 0 0'}}>
                                        <Typography variant={"subtitle1"}>
                                            {report.title}
                                        </Typography>
                                        <Typography component="h4" variant={"h4"}  style={{ marginTop: '10px'}}>
                                            {report.counter ? <CurrencyFormat value={report.counter} displayType={'text'} thousandSeparator={true}  /> : '-'}
                                        </Typography>
                                    </Paper>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Box>}
            </>
    );
}

export default MapReport;